import { VenueGroupConfig } from "../../types/VenueGroup";
import { VenueUserConfig } from "../../types/VenueUser";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { getEnvironmentProps } from "../../utils/environment";
import { throwApiError } from "../errorHandler";

type VenueGroupConfigResponse = {
  user?: VenueUserConfig;
  venueGroup?: VenueGroupConfig;
};
export const fetchVenueGroupConfig =
  async (): Promise<VenueGroupConfigResponse> => {
    const token = await dmnIdentity.getAccessToken();
    const environmentVars = getEnvironmentProps(token);

    const response = await fetch(
      `${environmentVars?.CORE_API_BASE_URL}/collins-config/venues_group`,
      {
        cache: "no-store",
        method: "GET",
        headers: {
          "cache-control": "no-store",
          Authorization: `Bearer ${token}`,
          source: "admin"
        }
      }
    );

    if (!response.ok) {
      await throwApiError(response, "Error fetching venue group config");
    }

    const responseData: VenueGroupConfigResponse = (await response.json())
      .payload;

    return responseData;
  };
